import React from 'react';
import Typography from '../../../atoms/Typography';
import Picture from '../../../atoms/Picture';
import { withNamespaces } from 'react-i18next';
import { withSitecoreContext, Text } from '@sitecore-jss/sitecore-jss-react';
import aspectRatios from '../../../../utils/AspectRatios';
import clsx from 'clsx';
import Link from '../../../atoms/Link';
import Favorite from '../../../atoms/Favorite';
import { get } from 'lodash';
import { formatArabicLangMonth, getUTCDateInUAEFormat } from '../../../../utils/dateTimeFunctions/dateTimeFunctions';

const ConditionalWrapper = ({ condition, wrapper, children }) =>
  condition ? wrapper(children) : children;

const AdCarouselItem = props => {
  const { index, item, startDate, endDate, language } = props;

  const category = get(item, 'eventCategories[0]', '');
  const id = get(item, 'itemUniqueKey', '');
  const title = get(item, 'name', '');
  const image = get(item, 'eventThumbnailImage', '');
  const cta = get(item, 'itemUrl', '');
  const isRtl = language === 'ar'
  const startDateMonth = startDate ? getUTCDateInUAEFormat(startDate, 'MMM') : '';
  const startDateDay = startDate ? getUTCDateInUAEFormat(startDate, 'DD') : '';
  const startTime = startDate ? getUTCDateInUAEFormat(startDate, 'hh:mm A') : '';
  const endDateMonth = endDate ? getUTCDateInUAEFormat(endDate, 'MMM') : '';
  const endDateDay = endDate ? getUTCDateInUAEFormat(endDate, 'DD') : '';
  const endTime = endDate ? getUTCDateInUAEFormat(endDate, 'hh:mm A') : '';

  const getFormattedDateAndTime = () => {
    let formattedDateAndTime = `${isRtl ? formatArabicLangMonth(startDate) : startDateMonth || ''} ${startDateDay}`;
    if (startDateMonth === endDateMonth) {
      if (startDateDay !== endDateDay) {
        formattedDateAndTime += ` - ${endDateDay}`;
      }
    } else {
      formattedDateAndTime += ` - ${isRtl ? formatArabicLangMonth(endDate) : endDateMonth || ''} ${endDateDay}`
    }
    formattedDateAndTime += `, ${startTime} - ${endTime}`;
    return formattedDateAndTime;
  }

  return (
    <>
      <ConditionalWrapper
        condition={cta}
        wrapper={children => (
          <div className='slide-overlay-wrapper'>
            <p className='slideNumber-bg'>{index + 1}</p>
            <Link link={{ value: { href: cta } }} draggable={false}>
              {children}
            </Link>
          </div>
        )}
      >
        <div className={clsx(props.className)}>
          <div className='slideItemsWrapper'>
            <div className='slidePictureWrapper'>
              <div className='slideElement'>
                <Picture
                  media={{
                    image: { value: { src: image } },
                    mobileImage: { value: { src: image } },
                    aspectRatio: aspectRatios['4x5'],
                    disableLazyLoad: true,
                    preferredSize: "medium"
                  }}
                  isParalax={false}
                  alternateAltText={title}
                />
              </div>
            </div>
            <div className='slideInformation'>
              <div className={'slideInformationTop'}>
                {category && (
                  <div className={'categoryLabel'}>
                    <Typography variant="body2" component="p" className="categoryLabelText">
                      {category}
                    </Typography>
                  </div>
                )}
                <div className={'favouriteWrapper'}>
                  <Favorite itemUniqueKey={id} />
                </div>
              </div>
              <div className={'slideInformationBottom'}>
                {language && startDate && endDate && (
                  <Typography component="p" variant="body2" className="timeText">
                    <Text field={{ value: getFormattedDateAndTime() }} />
                  </Typography>
                )}
                {title && (
                  <Typography variant="body1Bold22" component="p"
                    className="sliderTitle"
                    animateSettings={{
                      willAnimate: false,
                    }}>
                    {title}
                  </Typography>
                )}
              </div>
            </div>
          </div>
        </div>
      </ConditionalWrapper>
    </>
  );
};

export default withSitecoreContext()(withNamespaces()(AdCarouselItem));
